@if (!this.isPosting && !this.isPostingOver && !this.postError) {
<div
 
  class="poststates"
>
  {{ this.readyMessage }}
</div>
}

@if (this.isPosting && !this.isPostingOver && !this.postError) {
<div
 
  class="text-center"
>
  @if (!this.definedProgress) {
<div class="poststates__loader">
    <app-loader />
  </div>
}
  @if (this.definedProgress) {
<div class="mb-3">
    <ngb-progressbar class="mb-3" type="success" [value]="this.progress" [striped]="true" [showValue]="true" />
  </div>
}
  <div>{{ this.postingMessage }}</div>
</div>
}

@if (this.postError && !this.isPosting) {
<div class="poststates__postingerror">
  <div class="poststates__postingerror__crossmark">
    <i class="fa-solid fa-circle-exclamation"></i>
  </div>
  <div>
    {{ this.postError.message }}
  </div>
</div>
}

@if (this.isPostingOver) {
<div class="poststates__postingover">
  <div class="poststates__postingover__checkmark">
    <i class="fa-solid fa-circle-check"></i>
  </div>
  <div>
    {{ completeMessage }}
  </div>
</div>
}

